export default {
  getPermissions(context) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get("/partners-center/permissions")
        .then(response => {
          context.commit("setPermissions", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },

  // Profiles
  getProfiles(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/partners-center/perfis?${queryString}`)
        .then(({ data }) => {
          context.commit("setProfiles", data.results);
          resolve(data);
        })
        .catch(reject);
    });
  },

  getProfile(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/partners-center/perfis/${id}`)
        .then(({ data }) => {
          context.commit("setProfile", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  postProfile(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/partners-center/perfis", params)
        .then(resolve)
        .catch(reject);
    });
  },
  putProfile(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .put(`/partners-center/perfis/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  deleteProfile(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`/partners-center/perfis/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },

  // Invites sent
  getInvites(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/partners-center/invites?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setInvitesSent", results);
          resolve({ results, count, next, previous });
        })
        .catch(reject);
    });
  },
  postInvite(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/partners-center/invites", params)
        .then(resolve)
        .catch(reject);
    });
  },
  putInvite(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .put(`/partners-center/invites/${params.id}`, params)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },

  // Invites received
  getMyInvites(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/partners-center/invites/mine?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setInvitesReceived", results);
          resolve({ results, count, next, previous });
        })
        .catch(reject);
    });
  },
  putMyInvite(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .put(`/partners-center/invites/mine/${params.code}`, params)
        .then(resolve)
        .catch(reject);
    });
  },

  // Partners
  getPartners(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/partners-center?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setPartners", results);
          resolve({ results, count, next, previous });
        })
        .catch(reject);
    });
  },
  putPartner(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .put(`/partners-center/${params.id}`, params)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },

  // My Colabs
  getMyColabs(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/partners-center/mine?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setMyColabs", results);
          resolve({ results, count, next, previous });
        })
        .catch(reject);
    });
  }
};
